<template>
  <div class="outerbox">
    <table class="resultTable2">
      <tbody>
        <tr>
          <td class="resultdamacailable" style="width: 20%">
            <img
              src="/images/jackpot/logo_damacai.gif"
              width="50"
              height="38"
            />
          </td>
          <td class="resultdamacailable">
            Da Ma Cai 3+3D 大馬彩
          </td>
          <td class="resultdamacailable">
            <i
              id="d3live"
              class="fa fa-soccer-ball-o fa-spin fa-fw"
              style="display: none"
              aria-hidden="true"
              title="Live Draw"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
    <table class="resultTable2">
      <tbody>
        <tr>
          <td class="resultdrawdate" id="d3dd">
            Date: {{ showData(mktData.dd) }}
          </td>
          <td class="resultdrawdate" id="d3dn" style="text-align: right">
            Draw No: {{ showData(mktData.dn) }}
          </td>
        </tr>
      </tbody>
    </table>
    <table class="resultTable2">
      <tbody>
        <tr>
          <td style="width: 30%" class="resultprizelable">
            1st 首獎
          </td>
          <td class="resulttop" id="d3p1">
            {{ showData(mktData.n1) }}
          </td>
        </tr>
        <tr>
          <td style="width: 30%" class="resultprizelable">
            2nd 二獎
          </td>
          <td class="resulttop" id="d3p2">
            {{ showData(mktData.n2) }}
          </td>
        </tr>
        <tr>
          <td style="width: 30%" class="resultprizelable">
            3rd 三獎
          </td>
          <td class="resulttop" id="d3p3">
            {{ showData(mktData.n3) }}
          </td>
        </tr>
      </tbody>
    </table>
    <table class="resultTable2">
      <tbody>
        <tr>
          <td colspan="5" class="resultprizelable">
            Special 特別獎
          </td>
        </tr>
        <tr>
          <td class="resultbottom" id="d3s1">
            {{ showData(mktData.s1) }}
          </td>
          <td class="resultbottom" id="d3s2">
            {{ showData(mktData.s2) }}
          </td>
          <td class="resultbottom" id="d3s3">
            {{ showData(mktData.s3) }}
          </td>
        </tr>
        <tr>
          <td class="resultbottom" id="d3s4">
            {{ showData(mktData.s4) }}
          </td>
          <td class="resultbottom" id="d3s5">
            {{ showData(mktData.s5) }}
          </td>
          <td class="resultbottom" id="d3s6">
            {{ showData(mktData.s6) }}
          </td>
        </tr>
        <tr>
          <td class="resultbottom" id="d3s7">
            {{ showData(mktData.s7) }}
          </td>
          <td class="resultbottom" id="d3s8">
            {{ showData(mktData.s8) }}
          </td>
          <td class="resultbottom" id="d3s9">
            {{ showData(mktData.s9) }}
          </td>
        </tr>
        <tr>
          <td class="resultbottom">&nbsp;</td>
          <td class="resultbottom" id="d3s10">
            {{ showData(mktData.s10) }}
          </td>
          <td class="resultbottom">&nbsp;</td>
        </tr>
      </tbody>
    </table>
    <table class="resultTable2">
      <tbody>
        <tr>
          <td colspan="5" class="resultprizelable">
            Consolation 安慰獎
          </td>
        </tr>
        <tr>
          <td class="resultbottom" id="d3c1">
            {{ showData(mktData.c1) }}
          </td>
          <td class="resultbottom" id="d3c2">
            {{ showData(mktData.c2) }}
          </td>
          <td class="resultbottom" id="d3c3">
            {{ showData(mktData.c3) }}
          </td>
        </tr>
        <tr>
          <td class="resultbottom" id="d3c4">
            {{ showData(mktData.c4) }}
          </td>
          <td class="resultbottom" id="d3c5">
            {{ showData(mktData.c4) }}
          </td>
          <td class="resultbottom" id="d3c6">
            {{ showData(mktData.c6) }}
          </td>
        </tr>
        <tr>
          <td class="resultbottom" id="d3c7">
            {{ showData(mktData.c7) }}
          </td>
          <td class="resultbottom" id="d3c8">
            {{ showData(mktData.c8) }}
          </td>
          <td class="resultbottom" id="d3c9">
            {{ showData(mktData.c9) }}
          </td>
        </tr>
        <tr>
          <td class="resultbottom">&nbsp;</td>
          <td class="resultbottom" id="d3c10">
            {{ showData(mktData.c10) }}
          </td>
          <td class="resultbottom">&nbsp;</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: {
    mktData: {
      required: true,
      default: {},
    },
  },
  methods: {
    showData(value, append = "", prepend = "") {
      if (value == "" || value == undefined || value == null) {
        return "----";
      } else if (value.toString().includes("script")) {
        return `${append}${parseInt(
          value.toString().match(/\d+/)[0]
        )}${prepend}`;
      } else {
        return `${append}${value}${prepend}`;
      }
    },
    numberWithCommas(value) {
      if (value == "" || value == undefined || value == null) {
        return "----";
      } else {
        const number = parseFloat(value);
        const formattedNumber = number.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        return `RM ${formattedNumber}`;
      }
    },
  },
};
</script>

<style>
.outerbox {
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  border: #b4b4b4 1px solid;
  vertical-align: top;
  -moz-box-shadow: 0 0 2px 1px #ddd;
  -webkit-box-shadow: 0 0 2px 1px #ddd;
  box-shadow: 0 0 2px 1px #ddd;

  background-color: #fff;
  text-align: center;
  padding: 5px;
}

.resultTable2 {
  width: 100%;
  margin: 3px 0;
  padding: 0;
}
.resultm4dlable {
  background-color: #ff0;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  vertical-align: middle;
  color: #444;
  height: 26px;
}

.resultdamacailable {
  background-color: navy;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  vertical-align: middle;
  color: #fff;
  height: 26px;
}

.resultgdlottolable {
  background-color: #e81409;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  vertical-align: middle;
  color: #fff;
  height: 26px;
}

.resulttotolable {
  background-color: #ad0006;
  font-weight: 600;
  font-size: 18px;
  text-align: center;
  vertical-align: middle;
  color: #fff;
  height: 26px;
}

.resultprizelable {
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  background-color: #333;
  color: #fff;
  min-height: 25px;
  vertical-align: middle;
  padding: 5px 0;
  border-color: #333;
  border-style: solid;
  border-width: 1px;
}

.resultdrawdate {
  text-align: left;
  font-size: 14px;
  color: #333;
  padding: 5px 0;
  vertical-align: middle;
}

.resultbottom {
  text-align: center;
  font-size: 24px;
  color: #000;
  width: 20%;
  border-color: #ccc;
  border-style: solid;
  border-width: 1px;
  padding: 3px 0;
  height: 36px;
}

.jackpot-detail-box {
  height: auto;
  position: relative;
  margin-top: 180px;
}

@media (max-width: 959px) {
  .jackpot-detail-box {
    margin-top: 190px;
  }
}
@media (max-width: 599px) {
  .jackpot-detail-box {
    margin-top: 150px;
  }
}

.resulttop {
  font-size: 28px;
  color: #303030;
  font-weight: 700;
  text-align: center;
  border-color: #ccc;
  border-style: solid;
  border-width: 1px;
  padding: 2px 0;
  height: 40px;
}
</style>
